export default "__VITE_ASSET__ba9d950e__"